<template>
  <v-overlay v-if="isLoading" z-index="10">
    <v-progress-circular indeterminate size="64" />
  </v-overlay>
  <AppLayout
    centered
    v-else-if="currentWorker"
    customToolbar
    class="tabs-container"
  >
    <template v-slot:body>
      <div class="worker-details container col-lg-10 col-sm-12">
        <BackBar parent="/candidates" title="candidates" />
        <div class="d-flex justify-center mb-5">
          <div class="worker-icon">
            <v-icon>mdi-account-outline</v-icon>
          </div>
          <h2>{{ currentWorker | fullName }}</h2>
          <span class="tag my-auto ml-2 secondary-text">
            CSA-{{ currentWorkerId }}
          </span>
        </div>
        <v-tabs
          centered
          v-model="selectedTab"
          class="basic-tabs"
          @change="handleTabChange"
        >
          <v-tab v-for="section in sections" :key="section">
            {{ section | capitalize }}
          </v-tab>
        </v-tabs>
        <router-view :currentWorker="currentWorker" />
      </div>
    </template>
  </AppLayout>
</template>

<script>
import AppLayout from "@/components/common/base-layouts/AppLayout";
import BackBar from "@/components/common/base-layouts/BackBar";
import { FETCH_CURRENT_WORKER } from "@/store/modules/workers/action-types";
import { WORKERS_NAMESPACE } from "@/store/modules/workers";
import { createNamespacedHelpers } from "vuex";
import { MAIN_NAVIGATION_ITEMS } from "@/router/constants";
import { includes } from "lodash";
import { getFullName } from "@/utils/users";

const { mapActions, mapState } = createNamespacedHelpers(WORKERS_NAMESPACE);

const { CANDIDATES } = MAIN_NAVIGATION_ITEMS;
const TAB_INDEXES = {
  PROFILE: 0,
  ACTIVITY: 1
};

export default {
  name: "WorkerTabs",
  components: {
    AppLayout,
    BackBar
  },
  data() {
    return {
      selectedTab: 0
    };
  },
  computed: {
    ...mapState({
      currentWorker: state => state.currentWorker,
      isLoading: state => state.isFetchingData
    }),
    canDeleteWorker() {
      return true;
    },
    currentWorkerId() {
      return this.$route.params.id;
    },
    initialSection() {
      const path = this.$router.currentRoute.path;
      switch (true) {
        case includes(path, "profile"):
          return TAB_INDEXES.PROFILE;
        case includes(path, "activity"):
          return TAB_INDEXES.ACTIVITY;
        default:
          return TAB_INDEXES.PROFILE;
      }
    },
    sections() {
      return ["profile", "activity"];
    }
  },
  async created() {
    await this.fetchCurrentWorker(this.currentWorkerId);
    if (!this.currentWorker) {
      return this.$router.push("/pageNotFound");
    }
    this.selectedTab = this.initialSection;
    document.title = `${getFullName(this.currentWorker)} - Candidates - Track`;
  },
  methods: {
    ...mapActions({
      fetchCurrentWorker: FETCH_CURRENT_WORKER
    }),
    handleTabChange(selectedTab) {
      const tabName = this.sections[selectedTab];
      this.$router.replace(`/${CANDIDATES}/${this.currentWorkerId}/${tabName}`);
    }
  }
};
</script>

<style lang="scss">
.worker-details {
  .worker-icon {
    margin-right: 10px;
    display: flex;
    justify-content: center;
    background-color: rgba($primary, 0.1);
    border-radius: 4px;
    width: 40px;
    height: 40px;
  }
}
</style>
